export const checkIfMaintainanceOverDay = (
  startHr: number,
  startMin: number,
  endHr: number,
  endMin: number
) => {
  if (startHr > endHr) {
    return true;
  } else if (startHr < endHr) {
    return false;
  } else {
    if (startMin > endMin) {
      return true;
    }
    if (startMin < endMin) {
      return false;
    }
  }
  return false;
};
